module.exports = __webpack_public_path__ + "img/164.daace28a.jpg";